module.exports = __webpack_public_path__ + "media/images/newsletter-phone-1d61adc54497f15065d2348fb375da6c.png";